// externals
import React from 'react';

// libraries
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import { SpecialPaymentFormula, type IOffer, type IPencilOfferInputs } from '@makemydeal/dr-platform-types';
import * as dealHistorySelectors from '@makemydeal/dr-dash-store/selectors/dealHistorySelectors';

// components
import { OfferMessage } from '../offerMessage/OfferMessage.interstate';
import { StyledOfferCardContent } from './OfferCardContent.style';
import { OfferCardDetailsAB } from '../offerCardDetails/OfferCardDetailsAB';

// consts/enums
import { SELLING_PRICE } from '../constants';

type OfferCardContentProps = {
    offer: IOffer;
};

export const OfferCardContent = ({ offer }: OfferCardContentProps) => {
    const theme = useInterstateTheme();

    const { offerType, offerSource, penciledInputs, messageToDealer, message, cmdMessageToShopper: dealerMessage } = offer;

    const { condition, make, model, year, trim } = offer.vehicle;
    const vehicleTitle = `${condition} ${year} ${make} ${model} ${trim}`;

    const { term, offerPrice, annualMiles } = (offerType && penciledInputs?.byOfferType?.[offerType]) ?? ({} as IPencilOfferInputs);
    const payment = term && offer.terms?.byId?.[term];
    const offerPayment = dealHistorySelectors.getOfferPayment(offer);
    const specialPaymentFormula = dealHistorySelectors.getSpecialPaymentFormula(offerPayment);

    const specialPaymentData =
        specialPaymentFormula === SpecialPaymentFormula.FordFlexBuy
            ? {
                  specialPaymentFormula,
                  firstTerm: dealHistorySelectors.firstPaymentTerm(offerPayment),
                  secondTerm: dealHistorySelectors.secondPaymentTerm(offerPayment),
                  firstPaymentAmount: dealHistorySelectors.firstPaymentAmount(offerPayment),
                  secondPaymentAmount: dealHistorySelectors.secondPaymentAmount(offerPayment)
              }
            : undefined;

    const { monthlyPayment, netCashDown, totalAllowance, months, apr, baseResidualDollar } = payment || {};

    const offerCardAbPencilContent = () => {
        return (
            <StyledOfferCardContent theme={theme}>
                <div className="offer-card__details">
                    {offerType && (
                        <OfferCardDetailsAB
                            offerType={offerType}
                            monthlyPayment={monthlyPayment}
                            netCashDown={netCashDown}
                            tradeAllowance={totalAllowance}
                            offerPrice={offerPrice}
                            months={months}
                            apr={apr}
                            vehicleTitle={vehicleTitle}
                            annualMiles={annualMiles}
                            vehiclePriceLabel={SELLING_PRICE}
                            specialPaymentData={specialPaymentData}
                            balloonAmount={baseResidualDollar}
                        />
                    )}
                </div>
                {/* current or live offer doesnt use the same mapper as the compared (offerhistoryreducer) the property messageToDealer doesnt exist there */}
                <div className="offer-card__message">
                    <OfferMessage
                        shopperMessage={messageToDealer ?? message}
                        dealerMessage={dealerMessage}
                        offerSource={offerSource}
                    />
                </div>
            </StyledOfferCardContent>
        );
    };

    return offerCardAbPencilContent();
};
